export enum OnboardingStepTypes {
  COMMUNITY_EDIT = 'communityEdit',
  COMMUNITY_MEMBER = 'communityMember',
  COMMUNITY_POST_CREATE = 'communityPostCreate',
  COMMUNITY_SHARE = 'communityShare'
}
